export const MAP_GEOMETRY_TYPE = {
    POINT: 1,
    LINE: 2,
    AREA: 3
};
